export default __webpack_public_path__ + "static/media/Image3.7711321e.png";